// This file is automatically generated by @unitedtraders/i18n. Do not modify it directly.
const { resolve } = require('path');

module.exports = {
  module: {
    load: (ns, lng) => {
      const context = require.context(`../locales`, true, /.json$/, 'lazy');
      return context(`./${lng}/${ns}.json`);
    },
    getFilepath: (ns, lng) => resolve(__dirname, '..', 'locales', lng, ns) + '.json',
    namespaces: [
      'deposit',
      'byAdvCash',
      'byBank',
      'byCard',
      'byPayeer',
      'byUtex',
      'exceptions',
      'byUTT',
    ],
    langs: ['en', 'es', 'ru'],
  },
};
